import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import { ORGANIZATIONS_SEARCH_KEY } from 'api/search'
import axios from 'axios'

export interface DeleteItemInput {
  EntityType: 'organization' | 'deal' | 'product' | string
  items: { PK: string; SK: string }[]
  tableName?: string // Optional for future expansion
}

const deleteItems = async (payload: DeleteItemInput) => {
  const response = await axios.delete(`${baseUrl}/aws/delete/items`, { data: payload })
  if (response.status !== 200) throw new Error(response.data.message || 'Failed to delete items')
  return response.data
}

export const useDeleteItems = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteItems,
    onSuccess: (data, variables) => {
      console.log('data', data, 'variables', variables)
      // Invalidate search cache if organizations were deleted
      if (variables?.EntityType === 'organization') {
        queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_SEARCH_KEY })
      }
    },
    onError: error => {
      console.error('[useDeleteItems] Deletion error:', error)
    },
  })
}
